import React, {FC} from 'react';
import styled from 'styled-components';

import {boxShadow} from '../../../libs/shared/ui/src/theme/themeStyleHelpers';
import {InboxesVisualConversationSelection} from '../../store/panels/cells/helpers/cellsPanelSelectionHelpers';
import {ViewerPanelId} from '../../store/panels/panelStateBase';
import {ViewerPanelPageState} from '../../store/panels/viewer/viewerPanelState';
import {ConversationHeaderContainer} from '../inboxes/viewer/conversation/header/conversationHeaderContainer';
import {ViewerContainer} from '../inboxes/viewer/viewerContainer';
import {VisitorViewerSidebar} from './visitorViewerSidebar';

/*
 * Props.
 */

interface VisitorViewerProps {
  panelId: ViewerPanelId;
  topbarPage: ViewerPanelPageState;
  topbarConversationSelection: InboxesVisualConversationSelection;
  contentPage: ViewerPanelPageState;
}

/*
 * Style.
 */

const StyledGridDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: 100%;
  grid-auto-flow: column;
  min-height: 250px;
  height: 100%;
`;

const StyledSidebarDiv = styled.div`
  ${(p) => boxShadow(p.theme, `0 0 55px ${p.theme.alphas.black10}, 0 0 150px ${p.theme.alphas.black20}`)};
`;

/*
 * Component.
 */

export const VisitorViewer: FC<VisitorViewerProps> = (props) => (
  <StyledGridDiv>
    <ViewerContainer
      panelId={props.panelId}
      cellsPanelId={undefined}
      header={
        <ConversationHeaderContainer
          panelId={props.panelId}
          cellsPanelId={undefined}
          cellsContext={props.topbarPage.cellsContext}
          inboxesParameters={props.topbarPage.parameters}
          conversationSelection={props.topbarConversationSelection}
        />
      }
      contentPage={props.contentPage}
    />
    <StyledSidebarDiv>
      <VisitorViewerSidebar />
    </StyledSidebarDiv>
  </StyledGridDiv>
);
